import Http from 'axios'
import {
    API_URL,
    VERSION
} from '../../config/config'

function initialState() {
    return {
        user: [],
        loading: false,
        mobile_number: null,
    }
}

const getters = {
    loading: state => state.loading,
    user: state => state.user,
    mobile: state => state.mobile_number,
    isUserFromMainOffice: state => {
        return state.user.is_from_main_office
    }
};

const actions = {
    fetchCurrentUser({
                         commit,
                         state
                     },data=null) {
        if (state.user.length === 0 || data !== null) {
            commit('setLoading', true);
            Http.get(API_URL + VERSION + '/user')
                .then(response => {
                    commit('setUser', response.data.data);
                })
                .catch(error => {
                })
                .finally(() => {
                    commit('setLoading', false);
                })
        }
    },
    changePassword({
                       commit,
                       state
                   }, data) {
        commit('setLoading', true)
        return new Promise((resolve, reject) => {
            Http.post(API_URL + VERSION + '/profile/change-password', data)
                .then(response => {
                    commit('setLoading', false);
                    resolve(response)
                })
                .catch(error => {
                    commit('setLoading', false);
                    reject(error)
                })
        });
    },
    resetState({
                   commit
               }) {
        commit('resetState')
    }
};

const mutations = {
    setUser(state, items) {
        state.user = items
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    resetState(state) {
        state = Object.assign(state, initialState())
    },
    setMobile(state, mobile_number) {
        state.mobile_number = mobile_number
    },
    setPasswordChangeRequired(state, password_change_required) {
        state.user.password_change_required = 0;
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
